import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add auth token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('auth_token')) {
      localStorage.removeItem('auth_token');
      sessionStorage.removeItem('patron_auth');
    }
    return Promise.reject(error);
  }
);

// Current month helper
export const getCurrentMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Format percentage
export const formatPercent = (value) => {
  return `${value.toFixed(1)}%`;
};

// Google Sheets month format
export const getSheetMonth = (date = new Date()) => {
  const months = [
    'JANVIER', 'FEVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN',
    'JUILLET', 'AOUT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DECEMBRE'
  ];
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

// Seasonal coefficients for forecast
export const SEASONAL_COEFFICIENTS = {
  1: 0.65, // Janvier
  2: 0.68, // Février
  3: 0.75, // Mars
  4: 0.85, // Avril
  5: 1.05, // Mai
  6: 1.30, // Juin
  7: 1.75, // Juillet
  8: 1.85, // Août
  9: 1.45, // Septembre
  10: 1.05, // Octobre
  11: 0.72, // Novembre
  12: 0.80, // Décembre
};

// Predefined suppliers
export const SUPPLIERS = [
  'Métro', 'Peixos', 'Abrantes', 'Passionfroid', 
  'Singla', 'Viniterroirs', 'Boulpat', 'Père Puig'
];

// Loss reasons
export const LOSS_REASONS = [
  'Chute découpe',
  'Périmé',
  'Accident',
  'Erreur commande',
  'Autre'
];
